<template>
<div class="wrapper">
  <parallax class="page-header header-filter" :style="headerStyle">

    <div class="md-layout">
      <div class="md-layout-item mx-auto text-center">
        <div class="brand">
          <h1>JSBoards</h1>
          <h3>Skimboards made in Malta</h3>

          <md-button href="#/about#contact" class="md-raised md-primary">
            Order your skimboard
          </md-button>
          <div class="space-100">
          </div>
        </div>

      </div>
    </div>
  </parallax>
  <div class="main main-raised">
    <div class="md-layout-item md-size-25 mx-auto md-small-size-50">
      <md-card id="gallery">
        <carousel :per-page="1" loop :speed="700" autoplay :autoplay-timeout="5000" :mouse-drag="false" navigationEnabled navigationNextLabel="<i class='material-icons'>keyboard_arrow_right</i>"
          navigationPrevLabel="<i class='material-icons'>keyboard_arrow_left</i>">

          <slide>
            <div class="carousel-caption">
              <h4>
                <md-icon>info</md-icon>
                GLX-1 Turquoise
              </h4>
            </div>
            <img :src="carousel4" alt="GLX-1 Turquoise" />
          </slide>
          <slide>
            <div class="carousel-caption">
              <h4>
                <md-icon>info</md-icon>
                GLX-1 Pink
              </h4>
            </div>
            <img :src="carousel5" alt="GLX-1 Pink" />
          </slide>
          <slide>
            <div class="carousel-caption">
              <h4>
                <md-icon>info</md-icon>
                GLX-1 Purple
              </h4>
            </div>
            <img :src="carousel6" alt="GLX-1 Purple" />
          </slide>
        </carousel>
      </md-card>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "index",
  bodyClass: "index-page",
  props: {
    image: {
      type: String,
      default: require("@/assets/img/backgroundOpaque.jpg")
    }
  },
  mounted(){
    this.$emit("click");
  },
  data() {
    return {
      firstname: null,
      email: null,
      password: null,
      leafShow: false,
      carousel1: require("@/assets/img/board1-GPX-yellow-52.jpg"),
      carousel2: require("@/assets/img/board2-GPX-blue-white-52.jpg"),
      carousel3: require("@/assets/img/board3-GPX-green-52.jpg"),
      carousel4: require("@/assets/img/board4-GLX-turqoise-54.jpg"),
      carousel5: require("@/assets/img/board5-GLX-pink-49.jpg"),
      carousel6: require("@/assets/img/board6-GLX-purple-49.jpg")
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.image})`
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.section-download {
    .md-button + .md-button {
        margin-left: 5px;
    }
}

@media all and (min-width: 991px) {
    .btn-container {
        display: flex;
    }
}

@media (max-width: 768px) {
    .footer {
        nav {
            display: block;
        }
    }

    .brand h1 {
        font-size: 4.3rem;
    }

    .brand h3 {
        display: inline-block;
        max-width: 500px;
        line-height: 1;
        font-size: 1.7rem;
    }
}
</style>
